import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '$lib/lib/cn';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input({ className, ...rest }, ref) {
  return (
    <input
      ref={ref}
      className={cn(
        'h-8 w-full rounded-sm border border-rule-strong bg-surface px-2 text-sm text-fg',
        'placeholder:text-fg-subtle focus:border-accent focus:bg-surface',
        'transition-colors duration-fast',
        className
      )}
      {...rest}
    />
  );
});
